// UQ-vi-VN
module.exports = {
  "forTest": "test for UQ-vi-VN",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Gợi ý từ UNIQLO",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Sắp xếp theo",
  "text_filter": "Bộ lọc",
  "text_styling_book_search_results_number": "{total} kết quả",
  "text_active_filters": "Đang dùng bộ lọc",
  "text_styling_book_clear_all_filters": "Xóa tất cả",
  "text_styling_book_search_by_feature": "Tìm theo đặc tính",
  "text_styling_book_search_by_category": "Tìm theo danh mục",
  "text_styling_book_staff_customer_filter_all": "Tất cả",
  "text_styling_book_search_by_coordinate": "Tìm theo cách phối kiểu",
  "text_styling_book_staff_customer_filter_title": "Đăng bởi",
  "text_styling_book_search_by_height": "Tìm theo chiều cao",
  "text_styling_book_search_by_hashtag": "Tìm theo hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Khách hàng",
  "text_styling_book_staff_customer_filter_staff_styling": "Nhân viên UNIQLO",
  "text_apply_search_filter": "Áp dụng",
  "text_styling_book_no_results": "Không có kết quả",
  "text_error_title": "Dịch vụ tạm thời không khả dụng",
  "text_503_error_description-1": "Chúng tôi vô cùng xin lỗi, đã xảy ra lỗi.",
  "text_503_error_description-2": "Vui lòng quay lại sau hoặc bấm vào nút quay lại trên trình duyệt để trở về trang trước.",
  "text_503_error_instruction": "Nếu bạn có bất kỳ câu hỏi nào, vui lòng truy cập trang LIÊN HỆ VỚI CHÚNG TÔI.",
  "text_styling_book_go_to_top": "Trang chủ UNIQLO",
  "text_contactus": "Liên hệ với chúng tôi",
  "text_wishlist": "Yêu thích",
  "text_membership_info": "Tư cách thành viên",
  "text_wearing_items": "Danh mục sản phẩm",
  "text_color": "Màu sắc",
  "text_size": "Kích cỡ",
  "text_stylehint_non_listed_items_message_01": "*Các Sản phẩm không có hàng sẽ không được thể hiện thông tin.",
  "text_styling_book_related_styling_title": "Có thể bạn cũng thích",
  "text_style_styling_date_update": "Cập nhật",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} VND",
  "text_404": "Trang bạn tìm kiếm hiện không tồn tại",
  "text_official_styling_top_page_link": "Trang chủ phong cách chính",
  "text_stylehint_top_page_link": "Trang chủ StyleHint",
  "text_breadcrumbs_top": "UNIQLO",
  "text_a11y_close": "Đóng",
  "text_log_in": "Đăng nhập",
  "text_app_update_dialog_cancel": "Hủy",
  "text_menu": "Danh mục",
  "text_copyright": "Bản quyền thuộc Công ty TNHH UNIQLO. Bảo lưu mọi quyền.",
  "text_stylehintapp": "Ứng dụng StyleHint",
  "text_styling_book_official_styling_page_title": "Gợi ý từ UNIQLO",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Hàng mới về",
  "text_styling_book_sort_popular": "Phổ biến",
  "text_styling_book_search_by_color": "Tìm theo màu",
  "text_filter_clear_all_category": "Xóa tất cả các danh mục",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "HIỂN THỊ TẤT CẢ",
  "text_error_description": "Đã xảy ra lỗi hệ thống. Vui lòng thử lại hoặc quay lại sau.",
  "text_system_error": "Lỗi hệ thống",
  "text_ok": "OK",
  "text_login_required": "Yêu cầu đăng nhập",
  "text_login_request": "Vui lòng đến trang đăng nhập.",
  "text_error_failed_sort_product": "Không thể lọc sản phẩm theo tiêu chí lựa chọn của bạn. Vui lòng sử dụng tính năng sắp xếp lần nữa.",
  "text_error_failed_update_filter_criteria": "Không thể cập nhật tiêu chí lọc. Vui lòng thử lại lần nữa.",
  "text_meta_title_postfix": "| UNIQLO VN",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Nữ",
  "text_styling_book_meta_men": "Nam",
  "text_styling_book_meta_kids": "Trẻ Em",
  "text_styling_book_meta_baby": "Trẻ Nhỏ",
  "text_styling_book_official_gender_meta_description": "Khám phá lookbook của chúng tôi và tìm ra phong cách {gender} hoàn hảo mỗi mùa! Mua sắm ngay mọi phong cách hoặc thêm sản phẩm vào danh sách yêu thích và mua sắm sau.",
  "text_styling_book_official_gender_meta_title": "Khám phá phong cách mỗi mùa| {gender} | Phong Cách Chính Thức {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "Ý tưởng phong cách 「{filterOptions}」 {gender} {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Tham khảo ý tưởng phong cách phối 「{filterOptions}」{gender} với các trang phục thời trang từ {brand}. Tìm hiểu ngay cách phối trang phục theo xu hướng mùa mới.",
  "text_styling_book_official_detail_meta_title": "Cửa hàng bán sản phẩm 「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Khám phá phong cách mùa mới với「{officialProducts} và mua sắm tại {brand}.com ngay!",
  "text_styling_book_stylehint_gender_meta_title": "Xem thêm ý tưởng phong cách mới | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Lấy cảm hứng từ phong cách {gender} của khách hàng và mà nhân viên {brand} đã đăng trên ứng dụng StyleHint.",
  "text_styling_book_stylehint_filter_meta_title": "Ý tưởng phong cách 「{filterOptions}」 {gender} {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Ý tưởng phối đồ của {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Ý tưởng phối đồ của {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Ý tưởng phối đồ của {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Khám phá gợi ý phong cách cho「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Khám phá gợi ý phong cách phối đồ của nhân viên {brand}({storeName}) {staffName}({height}). Tìm hiểu ngay cách phối trang phục theo xu hướng mùa mới từ nhân viên của chúng tôi.",
  "text_styling_book_stylehint_ins_user_meta_description": "Khám phá cách phối trang phục {brand} từ outfit mà khách hàng「{userName}」đã chia sẻ trên Instagram. Xem thêm cách phối trang phục theo xu hướng mùa mới từ những khách hàng khác.",
  "text_styling_book_stylehint_customer_user_meta_description": "Tham khảo phong cách phối đồ {brand} theo xu hướng mùa mới của {userName} ({height}). Xem những sản phẩm mà người mẫu đã mặc trong ảnh tại cửa hàng online.",
  "text_styling_book_stylehint_detail_meta_description": "Khám phá một phong cách phối đồ mới với {stylehintProducts} từ khách hàng và nhân viên {brand} của chúng tôi. Mua sắm tại {brand}.com ngay!",
  "text_styling_book_stylehint_filter_meta_description": "Tham khảo 「{searchCount}」phong cách phối đồ {brand} cùng 「{filterOptions}」. Xem những sản phẩm mới và sản phẩm xu hướng tại cửa hàng online.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} STYLING BOOK ý tưởng phối đồ ID: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} STYLING BOOK ý tưởng Phong Cách ID: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Khám phá gợi ý phong cách cho 「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Khám phá gợi ý phong cách cho「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Gợi ý phong cách {gender} 「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Gợi ý phong cách cho {gender}「 {feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Chúng tôi vô cùng xin lỗi. Trang web đã xảy ra lỗi. Vui lòng quay lại sau hoặc bấm vào nút quay lại trên trình duyệt để trở về trang trước.",
  "text_styling_book_meta_official_styling": "gợi ý phong cách",
  "text_styling_book_meta_stylehint": "ý tưởng phối đồ",
  "text_limited_offer_until_date": "{flagName} từ {startDate} - {date}",
  "text_online_store_exclusive_limited_offer_until_date": "{flagName} từ {startDate} - {date}",
  "text_app_membership_exclusive_limited_offer_until": "{flagName} từ {startDate} - {date}",
  "text_csoon_early": "Có hàng vào đầu {month}",
  "text_csoon_mid": "Có hàng vào giữa {month}",
  "text_csoon_late": "Có hàng vào cuối {month}",
  "text_men": "Nam",
  "text_women": "Nữ",
  "text_kids": "Trẻ em",
  "text_baby": "Trẻ sơ sinh",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "Khuyến Mãi Dành Riêng Cho Thành Viên App",
  "text_styling_book_gender_menu_kids_and_baby": "Trẻ Em / Trẻ Sơ Sinh",
  "text_styling_book_meta_kids_and_baby": "KIDS・BABY",
  "text_a11y_favorites_add": "Thêm vào danh sách mong muốn",
  "text_close": "Đóng",
  "text_error_wishlist_max": "Bạn không thể thêm sản phẩm vào danh sách mong muốn của mình do vượt quá danh sách mong muốn tối đa là 999 sản phẩm.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Không có hình ảnh",
  "text_wearing_size_code01": "Size quần áo: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "Tiếng Việt",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "Sản phẩm này đã ngừng sản xuất.",
  "text_product_display_markdown": "",
  "text_color_white": "Trắng",
  "text_color_gray": "Xám",
  "text_color_black": "Đen",
  "text_color_pink": "Hồng",
  "text_color_red": "Đỏ",
  "text_color_orange": "Cam",
  "text_color_beige": "Màu be",
  "text_color_brown": "Nâu",
  "text_color_yellow": "Vàng",
  "text_color_green": "Xanh lá",
  "text_color_blue": "Xanh lam",
  "text_color_purple": "Tím",
  "text_promotion": "Khuyến mãi",
  "text_styling_promotion_hashtag": "Khuyến mãi",
  "text_coming_soon": "Sớm ra mắt",
  "text_markdown": "Hạ giá",
  "text_multibuy_markdown": "Mua gộp, hạ giá",
  "text_multibuy_limited_offer_until_date": "Mua gộp, ưu đãi có giới hạn đến {date}",
  "text_app_membership_exclusive_multi_buy_until": "{flagName} từ {startDate} - {date}",
  "text_app_membership_exclusive_multi_buy": "",
  "text_app_membership_exclusive_limitedoffers_until": "{flagName} từ {startDate} - {date}",
  "text_item_preorder_color_size_only": "Hàng mở bán trước (Một vài màu và size nhất định)",
  "text_item_resale_color_size_only": "Back in stock (một vài màu và size nhất định)"
}; // generated at Tue Jul 29 2025 17:11:03 GMT+0800 (Hong Kong Standard Time)